import { useEffect } from 'react';
import './index.less';
import config from '@config';

const Cumputerpreview = ({ content, preview }) => {
    useEffect(() => {
        if (preview) {
            let url = `${config.SURVEY_DOMAIN}/s/${content.id}/result`;
            if (content.route === 'newCreate') {
                url += '?template=1';
            } else {
                url += '?boss=1';
            }
            document.fr.location.href = url;
        }
    }, [content, preview]);

    return (
        <div className="cumputer-box">
            <iframe name="fr" className="iframe-width" />
        </div>
    );
};

export default Cumputerpreview;
